import * as regeneratorRuntime from 'regenerator-runtime';

Object.assign(window, {
    regeneratorRuntime,
});
